import {ApplicationRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {PedidosService} from "../../services/pedidos.service";
import {Router} from "@angular/router";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {ImpressaoService} from "../../services/impressao.service";
import {TelaImprimirPedido} from "../../fidelidade/TelaImprimirPedido";
import {MonitoradorPedidos} from "../../fidelidade/MonitoradorPedidos";
import {NgForm} from "@angular/forms";
import {EnumMomentoImprimirAuto} from "../../../../server/lib/emun/EnumMomentoImprimirAuto";
import {GrupolojasService} from "../../superadmin/services/grupolojas.service";
import {IOperacoesModuloPedidos} from "../../superadmin/services/ioperacoesmodulopedidos";
import {RotaGuardClient} from "../../guards/auth-loja.guard";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {EntregadorService} from "../../services/entregador.service";
import {timer} from "rxjs";

import { NfceService } from '../../services/nfce.service';
import {ContatosService} from "../../services/contatos.service";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'mudar-status',
  templateUrl: './mudar-status.component.html',
  styleUrls: ['./mudar-status.component.scss']
})
export class MudarStatusComponent extends TelaImprimirPedido implements OnInit , OnDestroy {
  @ViewChild('razaoCancelmentoComp',{ static: false}) razaoCancelmentoComp: any;
  @Input() urlRetorno: string;
  @Input() contato: any;
  private _modoGrupoLojas = false;
  @Input()
  set modoGrupoLojas(val: boolean) {
    this._modoGrupoLojas = val;
    this.apliqueEmpresaDoPedidoEmModoGrupo();
    this.carregueEntregadoresDoGrupoQuandoPossivel();
  }
  get modoGrupoLojas() {
    return this._modoGrupoLojas;
  }
  @Output() onAtualizouStatus = new EventEmitter();
  @Input() visivel = true;
  timerCancelamento: any;
  pedidoAlterado: any = {};
  motivoCancelamento: string
  StatusEmPreparacao = 1;

  codigosStatus = {
    "Novo": 0,
    "Em preparação": this.StatusEmPreparacao,
    "Pronto": 2,
    "Saiu para entrega": 3,
    "Entregue": 4,
    "Cancelado": 5,
    "Devolvido": 6
  }
  notificar: any = true;
  erro: string;
  salvando: boolean;
  cancelando: boolean;
  atualizarFoiPago: boolean;
  pagamento: any = {}
  @Input() entregadores: any;
  carregandoEntregadores: boolean;

  @Input()
  set pedido(val: any) {
    this._pedido = val;
    this.pedidoAlterado = {}

    Object.assign(this.pedidoAlterado, this._pedido)

    if(this.entregadores) {
      this.selecioneEntregadorNoPedido(this.entregadores)
    }

    if(this.pedidoAlterado.pago === undefined) this.pedidoAlterado.pago = false;

    this.atualizarFoiPago = !this._pedido.reposicaoInterna && !this._pedido.fiado &&
      (!this.pedidoAlterado.pago || !this.pedido.pontosGanhos) &&
      (!this._pedido.pagamentoOnline || this._pedido.pagamentoParcial)

    //if(this.pedido.do99food && !this.pedido.pago)
     // this.atualizarFoiPago = true;

    this._pedido.ehNovo = this.codigosStatus[this._pedido.status] === this.codigosStatus.Novo;

    if(this.novoStatus)
      this.pedidoAlterado.status = this.novoStatus

    if(this.pedido.balcao) this.notificar = false;

    this.apliqueEmpresaDoPedidoEmModoGrupo();
    this.carregueEntregadoresDoGrupoQuandoPossivel();

  }

  get pedido() {
    return this._pedido;
  }

  @Input()
  novoStatus: boolean;

  @Input()
  set exibirApenasAtualizarEntregador(val: any) {
    this._exibirApenasAtualizarEntregador = val;
  }

  get exibirApenasAtualizarEntregador() {
    return this._exibirApenasAtualizarEntregador
  }



  _exibirApenasAtualizarEntregador: boolean;
  private inicializado = false;

  constructor(protected pedidosService: PedidosService, private router: Router,  private constantsService: ConstantsService,
              public monitoradorPedidos: MonitoradorPedidos,   private  grupolojasService: GrupolojasService,
              protected impressao: ImpressaoService,  private autorizacaoService: AutorizacaoService,
              private entregadorService: EntregadorService,
              private app: ApplicationRef, protected nfeService: NfceService,
              private contatosService: ContatosService) {
    super(impressao, pedidosService, nfeService)
    this.carregandoEntregadores = true
  }

  ngOnInit() {
   this.notificar = true;
    this.inicializado = true;

    this.carregueEntregadores();

    if(!this.modoGrupoLojas)
      this.constantsService.empresa$.subscribe( empresa => this.empresa = empresa || {}  )

    if(this.novoStatus)
      this.pedidoAlterado.status = this.novoStatus

    this.apliqueEmpresaDoPedidoEmModoGrupo();
  }

  private carregueEntregadores() {
    if(this.entregadores) {
      this.carregandoEntregadores = false;
      this.selecioneEntregadorNoPedido(this.entregadores);
      return;
    }

    this.carregandoEntregadores = true;

    if(this.modoGrupoLojas) {
      const idEmpresa = Number(this.pedido?.empresa?.id);

      if(!idEmpresa) {
        this.carregandoEntregadores = false;
        return;
      }

      this.grupolojasService.listeEntregadores(idEmpresa).then((entregadores) => {
        this.carregandoEntregadores = false;
        this.entregadores = entregadores;
        this.selecioneEntregadorNoPedido(this.entregadores);
      }).catch(() => {
        this.carregandoEntregadores = false;
        this.entregadores = [];
      });
      return;
    }

    this.entregadorService.liste().then((entregadores) => {
      this.carregandoEntregadores = false;
      this.entregadores = entregadores;
      this.selecioneEntregadorNoPedido(this.entregadores);
    }).catch(() => {
      this.carregandoEntregadores = false;
      this.entregadores = [];
    });
  }

  private carregueEntregadoresDoGrupoQuandoPossivel() {
    if(!this.inicializado || !this.modoGrupoLojas || this.entregadores || this.carregandoEntregadores) return;
    if(!this.pedido?.empresa?.id) return;

    this.carregueEntregadores();
  }

  private apliqueEmpresaDoPedidoEmModoGrupo() {
    if(this.modoGrupoLojas && this._pedido?.empresa)
      this.empresa = this._pedido.empresa;
  }



  obtenhaNovosStatus(){
    let novosStatus = [ ]

    if(this.pedido.naoAlterarStatus){
      novosStatus.push(this.pedido.status)
    } else {
      if(this.temPermissaoAlterarStatus()  && this.pedidoPodeSerAlterado()){
        novosStatus = ['Em preparação', 'Pronto'];

        const origemExterna = this.pedido.externo != null; //ifood,ketta,99food etc

        const delivery = this.pedido.formaDeEntrega && this.pedido.formaDeEntrega !== 'Retirar';

        if( !origemExterna || this.pedido.externo.entregaPelaLoja || (this.pedido.do99food && this.pedido.retirar)){
          if(delivery)  novosStatus.push('Saiu para entrega')

          novosStatus.push('Entregue')
        }
      }
    }

    if(this.temPermissaCancelarPedido() && !this.pedidoComandaFechada())
      novosStatus.push('Cancelado')


    return novosStatus;
  }

  submitForm(frm: NgForm){
    if(this.pedidoComandaFechada()){
      this.onAtualizouStatus.emit(null)
      return;
    }

    if(frm && !frm.valid) return;

    if(this.vaiCancelar())
      return this.cancelePedido();

    return this.atualizarStatus();
  }

  cancelePedido(){
    delete   this.erro;
    if(this.cancelando) return;
    this.cancelando = true;
    delete this.pedido.motivoRejeicao;

    let motivo: any =  this.razaoCancelmentoComp ? this.razaoCancelmentoComp.razaoCancelamento : this.motivoCancelamento ;

    if(this.pedido.doKeeta || this.pedido.do99food)
       motivo.texto = this.motivoCancelamento;

    this.getService().cancelePedido(this.pedido, motivo, this.notificar).then(async (resposta) => {

      if(resposta.aguardandoPdv  ) {
        this.pedido.aguardandoPdv = true;
        this.inicieMonitoramentoCancelamento(resposta.idEvent);
      } else if(resposta.aguardarGateway) {
        this.pedido.aguardandoEstorno = true;
        this.pedidoAlterado.status = null;
      } else {
       this.setPedidoCancelado();
      }
    }).catch( (erro) => {
      this.cancelando = false;
      this.erro = erro;
    })
  }

  setPedidoCancelado(){
    this.cancelando = false;
    this.pedido.cancelado =  true;
    this.pedido.status = this.pedidoAlterado.status
    this.atualizouStatus(false);
  }

  ngOnDestroy(): void {
    this.pareMonitoramento();
  }

  pareMonitoramento(){
    this.pedido.aguardandoPdv = false;
    this.cancelando = false;

    if( this.timerCancelamento)
      this.timerCancelamento.unsubscribe();
  }

  inicieMonitoramentoCancelamento(idEvent){
    let segundosTimer = 5;
    this.timerCancelamento =  timer(2000, 1000 * segundosTimer  ).subscribe( () => {
       console.log('verificar pedido: ' + this.pedido.id)
       this.getService().obtenhaStatusCancelamento(this.pedido, idEvent).then( (resposta: any) => {
         if(resposta.pdvReconheceu)  this.pedido.pdvReconheceu = true;

         if(resposta.rejeitouCancelamento){
           this.pedido.motivoRejeicao  =  resposta.motivo;
           this.pareMonitoramento();
         }

          if(resposta.cancelado){
            this.setPedidoCancelado();
            this.pareMonitoramento();
          }
       })
    });
  }

  atualizarStatus(cb: any = null ) {
    delete   this.erro;
    if(this.salvando) return;
    this.salvando = true;

    let codigoNovoStatus = this.codigosStatus[this.pedidoAlterado.status];

    this.getService().altereStatus(this.pedido, codigoNovoStatus, this.notificar).then(async (resposta) => {
      const respostaStatus = resposta || {};

      if(respostaStatus.erroNotificar)
        this.erro = respostaStatus.erroNotificar;

      if(respostaStatus.delivery)
          this.pedido.delivery = respostaStatus.delivery;

      if(this.pedido.status !==  this.pedidoAlterado.status){
        this.pedido.status = this.pedidoAlterado.status
        this.pedido.cancelado = respostaStatus.cancelado;
        let empresaPedido = this._pedido.empresa || this.empresa;
        if( codigoNovoStatus === this.StatusEmPreparacao && empresaPedido?.aceitarPedidoAutomatico)
          if(this.empresa?.configImpressao && this.empresa.configImpressao.momentoImprimirAuto !== EnumMomentoImprimirAuto.NovoPedido)
            await this.envieImpressaoAutomatica();

      }

      if(this.pedidoAlterado.objetoEntregador) {
        if(!this.pedido.objetoEntregador || this.pedidoAlterado.objetoEntregador.id !== this.pedido.objetoEntregador.id) {
          await this.getService().altereEntregador(this.pedido, this.pedidoAlterado.objetoEntregador)
          this.pedido.objetoEntregador = this.pedidoAlterado.objetoEntregador
          this.pedido.entregador = this.pedidoAlterado.objetoEntregador.nome
          this.pedido.entregadorReduzido = this.pedidoAlterado.objetoEntregador.nomeReduzido
        }
      }

      if(this.atualizarFoiPago && this.pedidoAlterado.pago !== this.pedido.pago && !this.vaiCancelar()) {
       if(this.pedidoAlterado.pago && this.pedido.pagamentoParcial && !this.pagamento.formaDePagamento) {
         this.salvando = false;
         this.erro = 'Informe a forma de pagamento em que o saldo foi recebido.';
         if(cb) cb(false, this.erro);
         return;
       }

       this.getService().altereFoiPago(this.pedido, this.pedidoAlterado.pago, this.pagamento.formaDePagamento).then((resp) => {
          this.pedido.pago = this.pedidoAlterado.pago;
          if(this.pedido.pago && this.pedido.pagamentoParcial) {
            // saldo recebido no servidor: o resumo derivado passa a quitado
            this.pedido.valorRecebido = this.pedido.total;
            this.pedido.saldoPendente = 0;
            this.pedido.pagamentoParcial = false;
            this.pedido.situacaoPagamento = 'quitado';
          }
          this.atualizouStatus(resp.redirectAdicionarPontos);

          if(cb) cb(true);

        }).catch( (erro) => {
            this.salvando = false;
            this.erro = erro;
            if(cb) cb(false, erro);
        })
      } else {
          this.atualizouStatus(false);
          if(cb) cb(true);
      }
    }).catch( (erro) => {
      this.salvando = false;
      this.erro = erro;
      if(cb) cb(false, erro);
    })
  }

  atualizouStatus(redirectAdicionarPontos){
    this.onAtualizouStatus.emit(this.erro);

    if(this.pedido.ehNovo)
      this.monitoradorPedidos.alterouStatusPedido(this.pedido);

    if(this.pedido.pago &&  redirectAdicionarPontos && !this.erro)
      this.adcionarPontos(this.contato, this.pedido.subvalor)
    else {
      if(this.urlRetorno && !this.erro)
        this.router.navigateByUrl(this.urlRetorno, {state: { mensagem: 'Pedido  #' + this.pedido.codigo + ' atualizado com sucesso!'}});

      this.salvando = false;
    }

  }

  async adcionarPontos(contato: any, valor: number) {
    contato = await this.obtenhaContatoCompletoParaFidelidade(contato);

    let state: any = { contato: contato, valor: valor };
    let urlRetorno = this.urlRetorno ? this.urlRetorno : this.router.url

    if(contato.cartoes && contato.cartoes.length ){
       if(contato.cartoes.length === 1)
         state.cartao = contato.cartoes[0];

       await this.router.navigateByUrl('/admin/contatos/pontos/adicionar?urlRetorno=' + urlRetorno,
        { state: state });
    } else {

      await this.router.navigateByUrl('/admin/contatos/novo?urlRetorno=' + urlRetorno,
        { state: state });
    }
  }

  private async obtenhaContatoCompletoParaFidelidade(contato: any) {
    const telefoneCompleto = this.obtenhaTelefoneCompletoContato(contato);

    if(!telefoneCompleto)
      return contato;

    try {
      const contatoCompleto = await this.contatosService.obtenhaContato(telefoneCompleto);
      return contatoCompleto || contato;
    } catch (e) {
      return contato;
    }
  }

  private obtenhaTelefoneCompletoContato(contato: any) {
    if(!contato)
      return null;

    if(contato.codigoPais && contato.telefone)
      return String(contato.codigoPais) + String(contato.telefone);

    if(typeof contato.telefone === 'string' && contato.telefone.indexOf('+') === 0)
      return contato.telefone;

    return null;
  }

  getService(): IOperacoesModuloPedidos {
    if (this.modoGrupoLojas)
      return this.grupolojasService;

    return this.pedidosService;
  }


  vaiCancelar() {
    return this.pedidoAlterado.status === 'Cancelado' || this.pedidoAlterado.status === 'Devolvido'
  }

  estornarOnline() {
    if(this.vaiCancelar() && !this._pedido.origemExterna)
      return  this._pedido.pagamentoOnline && this._pedido.pago ;

    return false;
  }

  temPermissaCancelarPedido() {
    return RotaGuardClient.cancelarPedido(this.autorizacaoService.getUser())
  }

  temPermissaoAlterarStatus(){
    return RotaGuardClient.alterarStatusPedido(this.autorizacaoService.getUser())

  }

  pedidoPodeSerAlterado(){
    if(this.pedido.aguardandoPagamentoOnline) return false;

    if(this.pedido.comanda && !this.pedido.comanda.aberta)
      return false;

    if(this.pedido.agendadoParaOutroDia) return  false;

    return true;
  }

  pedidoComandaFechada(){
    if(this.pedido.comanda && this.pedido.comanda.id)
      return !this.pedido.comanda.aberta;

    return false;
  }

  private selecioneEntregadorNoPedido(entregadores: any) {
    for(let entregador of entregadores)
      if(this.pedidoAlterado.objetoEntregador && this.pedidoAlterado.objetoEntregador.id === entregador.id) {
        this.pedidoAlterado.objetoEntregador = entregador
        this.app.tick();
        /*         setTimeout(() => {

                 }, 0)*/
      }

  }
}
